import { cameraNodeyTemplate as e } from "./nodey-graph-templates/camera.js";
import { cameraLookGenNodeyTemplate as t } from "./nodey-graph-templates/camera-look-gen.js";
import { cameraSnapshotTemplate as n } from "./nodey-graph-templates/camera-snapshot.js";
import { imageGenNodeyTemplate as r } from "./nodey-graph-templates/image-gen.js";
import { meshGenNodeyTemplate as i } from "./nodey-graph-templates/mesh-gen.js";
import { createStore as a } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/index.mjs";
import { useStore as o } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/react.mjs";
import { useShallow as s } from "/home/runner/work/oko-web/oko-web/node_modules/zustand/esm/react/shallow.mjs";
import { handleSubscribers as c } from "@magnopus-opensource/connected-spaces-platform-web-api";
import { environment as l, getNodeyServerUrl as u, getStreamingOrigin as d } from "@magnopus/env";
var f = {
	camera: e,
	lookGen: t,
	imageGen: r,
	meshGen: i,
	asset: (e) => null,
	snapshot: n
}, p = a((e) => ({
	accessToken: void 0,
	initialGraph: null,
	setInitialGraph: (t) => {
		e(() => ({ initialGraph: t }));
	},
	graphContext: null,
	setGraphContext: (t) => {
		e(() => ({ graphContext: t }));
	},
	savedGraphs: {
		camera: null,
		lookGen: null,
		imageGen: null,
		meshGen: null,
		asset: null,
		snapshot: null
	},
	setSavedGraph: (t, n) => {
		e((e) => ({ savedGraphs: {
			...e.savedGraphs,
			[t]: n
		} }));
	},
	clearSavedGraph: (t) => {
		e((e) => ({ savedGraphs: {
			...e.savedGraphs,
			[t]: null
		} }));
	},
	clearAllSavedGraphs: () => {
		e(() => ({ savedGraphs: {
			camera: null,
			lookGen: null,
			imageGen: null,
			meshGen: null,
			asset: null,
			snapshot: null
		} }));
	},
	nodeyEmbedApi: null,
	setNodeyEmbedApi: (t) => e({ nodeyEmbedApi: t }),
	activeNodeyEmbedApi: null,
	setActiveNodeyEmbedApi: (t) => e({ activeNodeyEmbedApi: t })
}));
c(p);
var m = (e) => o(p, s(e)), h = (e) => !!e && Object.keys(e.nodes).length > 0, g = () => {
	let { activeNodeyEmbedApi: e, savedGraphs: t } = p.getState();
	return h(e ? e.getGraph() : t.asset);
}, _ = (e, t) => (p.setState({ accessToken: t() }), e(() => p.setState({ accessToken: t() }))), v = () => m((e) => ({
	serverUrl: u(),
	mcsBaseUrl: l.endpoints.CHS_BASE,
	mcsCdnOrigin: d(),
	cloudEnabled: l.nodey?.cloudEnabled ?? !0,
	accessToken: e.accessToken,
	showVersionBadge: !0,
	showBuildHash: l.type === "dev"
}));
//#endregion
export { f as GRAPH_TEMPLATES, h as graphHasNodes, g as hasActiveNodeyGraph, _ as initNodeyAccessTokenSync, p as nodeyStore, v as useNodeyEmbedParameters, m as useNodeyStore };
